"use strict";
/* eslint-disable promise/catch-or-return */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcCommunicator = exports.StatusCode = void 0;
const Err = __importStar(require("./errors"));
const errors_1 = require("./errors");
const ClientTransport_1 = require("./ClientTransport");
const ProtoRpc_1 = require("../generated/ProtoRpc");
const ServerRegistry_1 = require("./ServerRegistry");
const runtime_rpc_1 = require("@protobuf-ts/runtime-rpc");
const utils_1 = require("@streamr/utils");
var StatusCode;
(function (StatusCode) {
    StatusCode["OK"] = "OK";
    StatusCode["STOPPED"] = "STOPPED";
    StatusCode["DEADLINE_EXCEEDED"] = "DEADLINE_EXCEEDED";
    StatusCode["SERVER_ERROR"] = "SERVER_ERROR";
})(StatusCode || (exports.StatusCode = StatusCode = {}));
class OngoingRequest {
    deferredPromises;
    callContext;
    timeoutRef;
    constructor(deferredPromises, callContext, timeoutOptions) {
        this.deferredPromises = deferredPromises;
        this.callContext = callContext;
        if (timeoutOptions) {
            this.timeoutRef = setTimeout(() => {
                const error = new Err.RpcTimeout('Rpc request timed out', new Error());
                this.rejectDeferredPromises(error, StatusCode.DEADLINE_EXCEEDED);
                timeoutOptions.onTimeout();
            }, timeoutOptions.timeout);
        }
    }
    resolveRequest(response) {
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }
        this.resolveDeferredPromises(response);
    }
    resolveNotification() {
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }
        if (this.deferredPromises.message.state === runtime_rpc_1.DeferredState.PENDING) {
            this.deferredPromises.message.resolve({});
            this.deferredPromises.header.resolve({});
            this.deferredPromises.status.resolve({ code: StatusCode.OK, detail: '' });
            this.deferredPromises.trailer.resolve({});
        }
    }
    rejectRequest(error, code) {
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }
        this.rejectDeferredPromises(error, code);
    }
    resolveDeferredPromises(response) {
        if (this.deferredPromises.message.state === runtime_rpc_1.DeferredState.PENDING) {
            try {
                const parsedResponse = this.deferredPromises.messageParser(response.body.value);
                this.deferredPromises.message.resolve(parsedResponse);
                this.deferredPromises.header.resolve({});
                this.deferredPromises.status.resolve({ code: StatusCode.OK, detail: '' });
                this.deferredPromises.trailer.resolve({});
            }
            catch (err) {
                logger.debug(`Could not parse response, received message is likely `);
                const error = new Err.FailedToParse(`Failed to parse received response, network protocol version likely is likely incompatible`, err);
                this.rejectDeferredPromises(error, StatusCode.SERVER_ERROR);
            }
        }
    }
    rejectDeferredPromises(error, code) {
        if (this.deferredPromises.message.state === runtime_rpc_1.DeferredState.PENDING) {
            this.deferredPromises.message.reject(error);
            this.deferredPromises.header.reject(error);
            this.deferredPromises.status.reject({ code, detail: error.message });
            this.deferredPromises.trailer.reject(error);
        }
    }
    fulfillsPredicate(predicate) {
        return predicate(this);
    }
    getCallContext() {
        return this.callContext;
    }
}
const logger = new utils_1.Logger(module);
class RpcCommunicator {
    stopped = false;
    rpcClientTransport;
    rpcServerRegistry;
    ongoingRequests;
    rpcRequestTimeout;
    outgoingMessageListener;
    constructor(params) {
        this.rpcRequestTimeout = params?.rpcRequestTimeout ?? 5000;
        this.rpcClientTransport = new ClientTransport_1.ClientTransport(this.rpcRequestTimeout);
        this.rpcServerRegistry = new ServerRegistry_1.ServerRegistry();
        this.ongoingRequests = new Map();
        // Client side listener for outgoing request
        this.rpcClientTransport.on('rpcRequest', (rpcMessage, options, deferredPromises) => {
            this.onOutgoingMessage(rpcMessage, options, deferredPromises);
        });
    }
    async handleIncomingMessage(message, callContext) {
        if (this.stopped) {
            return;
        }
        return this.onIncomingMessage(message, callContext);
    }
    registerRpcMethod(requestClass, returnClass, name, fn, options = {}) {
        this.rpcServerRegistry.registerRpcMethod(requestClass, returnClass, name, fn, options);
    }
    registerRpcNotification(requestClass, name, fn, options = {}) {
        this.rpcServerRegistry.registerRpcNotification(requestClass, name, fn, options);
    }
    getRpcClientTransport() {
        return this.rpcClientTransport;
    }
    stop() {
        this.stopped = true;
        this.ongoingRequests.forEach((ongoingRequest) => {
            ongoingRequest.rejectRequest(new Error('stopped'), StatusCode.STOPPED);
        });
        this.ongoingRequests.clear();
        this.rpcClientTransport.stop();
    }
    onOutgoingMessage(rpcMessage, callContext, deferredPromises) {
        if (this.stopped) {
            if (deferredPromises) {
                const ongoingRequest = new OngoingRequest(deferredPromises, callContext);
                ongoingRequest.rejectRequest(new Error('stopped'), StatusCode.STOPPED);
            }
            return;
        }
        const requestOptions = this.rpcClientTransport.mergeOptions(callContext);
        // do not register a notification
        if (deferredPromises && (!callContext || !callContext.notification)) {
            this.registerRequest(rpcMessage.requestId, deferredPromises, callContext, requestOptions.timeout);
        }
        logger.trace(`onOutGoingMessage, messageId: ${rpcMessage.requestId}`);
        if (this.outgoingMessageListener) {
            this.outgoingMessageListener(rpcMessage, rpcMessage.requestId, callContext)
                .catch((clientSideException) => {
                if (deferredPromises) {
                    if (this.ongoingRequests.has(rpcMessage.requestId)) {
                        this.handleClientError(rpcMessage.requestId, clientSideException);
                    }
                    else {
                        const ongoingRequest = new OngoingRequest(deferredPromises, callContext);
                        ongoingRequest.rejectRequest(clientSideException, StatusCode.SERVER_ERROR);
                    }
                }
            })
                .then(() => {
                if (deferredPromises) {
                    if (!this.ongoingRequests.has(rpcMessage.requestId)) {
                        const ongoingRequest = new OngoingRequest(deferredPromises, callContext);
                        ongoingRequest.resolveNotification();
                    }
                }
            });
        }
        else if (deferredPromises) {
            if (!this.ongoingRequests.has(rpcMessage.requestId)) {
                const ongoingRequest = new OngoingRequest(deferredPromises, callContext);
                ongoingRequest.resolveNotification();
            }
        }
    }
    async onIncomingMessage(rpcMessage, callContext) {
        logger.trace(`onIncomingMessage, requestId: ${rpcMessage.requestId}`);
        if (rpcMessage.header.response && this.ongoingRequests.has(rpcMessage.requestId)) {
            if (rpcMessage.errorType !== undefined) {
                this.rejectOngoingRequest(rpcMessage);
            }
            else {
                this.resolveOngoingRequest(rpcMessage);
            }
        }
        else if (rpcMessage.header.request && rpcMessage.header.method) {
            if (rpcMessage.header.notification) {
                await this.handleNotification(rpcMessage, callContext);
            }
            else {
                await this.handleRequest(rpcMessage, callContext);
            }
        }
    }
    async handleRequest(rpcMessage, callContext) {
        if (this.stopped) {
            return;
        }
        let response;
        try {
            const bytes = await this.rpcServerRegistry.handleRequest(rpcMessage, callContext);
            response = this.createResponseRpcMessage({
                request: rpcMessage,
                body: bytes
            });
        }
        catch (err) {
            const errorParams = { request: rpcMessage };
            if (err.code === errors_1.ErrorCode.UNKNOWN_RPC_METHOD) {
                errorParams.errorType = ProtoRpc_1.RpcErrorType.UNKNOWN_RPC_METHOD;
            }
            else if (err.code === errors_1.ErrorCode.RPC_TIMEOUT) {
                errorParams.errorType = ProtoRpc_1.RpcErrorType.SERVER_TIMEOUT;
            }
            else {
                errorParams.errorType = ProtoRpc_1.RpcErrorType.SERVER_ERROR;
                if (err.className) {
                    errorParams.errorClassName = err.className;
                }
                if (err.code) {
                    errorParams.errorCode = err.code;
                }
                if (err.message) {
                    errorParams.errorMessage = err.message;
                }
            }
            response = this.createResponseRpcMessage(errorParams);
        }
        this.onOutgoingMessage(response, callContext, undefined);
    }
    async handleNotification(rpcMessage, callContext) {
        if (this.stopped) {
            return;
        }
        try {
            await this.rpcServerRegistry.handleNotification(rpcMessage, callContext);
        }
        catch (err) {
            logger.debug('error', { err });
        }
    }
    registerRequest(requestId, deferredPromises, callContext, timeout = this.rpcRequestTimeout) {
        if (this.stopped) {
            return;
        }
        const ongoingRequest = new OngoingRequest(deferredPromises, callContext, {
            timeout,
            onTimeout: () => this.ongoingRequests.delete(requestId)
        });
        this.ongoingRequests.set(requestId, ongoingRequest);
    }
    resolveOngoingRequest(response) {
        if (this.stopped) {
            return;
        }
        const ongoingRequest = this.ongoingRequests.get(response.requestId);
        ongoingRequest.resolveRequest(response);
        this.ongoingRequests.delete(response.requestId);
    }
    rejectOngoingRequest(response) {
        if (this.stopped) {
            return;
        }
        const ongoingRequest = this.ongoingRequests.get(response.requestId);
        let error;
        if (response.errorType === ProtoRpc_1.RpcErrorType.SERVER_TIMEOUT) {
            error = new Err.RpcTimeout('Server timed out on request');
        }
        else if (response.errorType === ProtoRpc_1.RpcErrorType.UNKNOWN_RPC_METHOD) {
            error = new Err.UnknownRpcMethod(`Server does not implement method ${response.header.method}`);
        }
        else if (response.errorType === ProtoRpc_1.RpcErrorType.SERVER_ERROR) {
            error = new Err.RpcServerError(response.errorMessage, response.errorClassName, response.errorCode);
        }
        else {
            error = new Err.RpcRequest('Unknown RPC Error');
        }
        ongoingRequest.rejectRequest(error, StatusCode.SERVER_ERROR);
        this.ongoingRequests.delete(response.requestId);
    }
    handleClientError(requestId, error) {
        if (this.stopped) {
            return;
        }
        const ongoingRequest = this.ongoingRequests.get(requestId);
        if (ongoingRequest) {
            ongoingRequest.rejectRequest(error, StatusCode.SERVER_ERROR);
            this.ongoingRequests.delete(requestId);
        }
    }
    setOutgoingMessageListener(listener) {
        this.outgoingMessageListener = listener;
    }
    getRequestIds(predicate) {
        return Array.from(this.ongoingRequests.entries()).filter(([_, request]) => request.fulfillsPredicate(predicate)).map(([id]) => id);
    }
    // eslint-disable-next-line class-methods-use-this
    createResponseRpcMessage({ request, body, errorType, errorClassName, errorCode, errorMessage }) {
        return {
            body,
            header: {
                response: 'response',
                method: request.header.method
            },
            requestId: request.requestId,
            errorType,
            errorClassName,
            errorCode,
            errorMessage
        };
    }
}
exports.RpcCommunicator = RpcCommunicator;
//# sourceMappingURL=RpcCommunicator.js.map